import React from 'react'
import PropTypes from 'prop-types'
import { Level, LevelItem, LevelLeft, Button } from '../../bulma'
import { MobileSidebar } from '../../core'
import SidebarFilters from './SidebarFilters'

/**
* Container component for side bar filters for mobile devices. Manages sidebar
* state.
*/
class MobileFiltersContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
    }

    // Filter scope. Used for analytics event tracking.
    this.uid = 'Mobile Menu Filters'

    this.toggleMenu = this.toggleMenu.bind(this)
    this.checkVisibility = this.checkVisibility.bind(this)
  }

  /**
  * Toggles the sidebar's state. Passed down to children components. Also adds
  * and removes a the visibility event listener to know when the state should
  * be switched to closed once the screen gets too large for the mobile menu.
  */
  toggleMenu(source) {
    // Add or remove the visiblity checker before setting the new state.
    if (this.state.open) {
      window.removeEventListener('resize', this.checkVisibility)
      $.track('event', this.uid, 'Close', source)
    } else {
      window.addEventListener('resize', this.checkVisibility)
      $.track('event', this.uid, 'Open', source)
    }

    this.setState({ open: !this.state.open })
  }

  /**
  * Window Resize Event Handler. Checks to see if the window is resized to
  * larger than the mobile breakpoint. If the sidebar is open and the window is
  * larger than mobile, then the menu is toggled closed automatically. This
  * will remove any side effects that are added to the sidebar context that
  * prevents background scrolling while the sidebar is open.
  */
  checkVisibility() {
    if (!this.state.open) {
      return
    }

    // TODO: Global js breakpoint variables?
    if (window.innerWidth >= 768) {
      this.toggleMenu('Resize')
    }
  }

  render() {
    return (
      <div className="mobile-filters-container is-hidden-tablet">
        <Level isMobile className="is-marginless">
          <LevelLeft>
            <LevelItem>
              <Button
                isOutlined
                onClick={() => this.toggleMenu('Filter Button')}
              >
                Filter Results
              </Button>
            </LevelItem>
          </LevelLeft>
        </Level>
        <MobileSidebar
          isOpen={this.state.open}
          toggleSidebar={this.toggleMenu}
          side="left"
        >
          <div className="is-scrollable">
            <SidebarFilters
              name={this.uid}
              aggregations={this.props.aggregations}
              filters={this.props.filters}
              onChange={this.props.onChange}
              isLoading={this.props.isLoading || !this.state.open}
            />
          </div>
        </MobileSidebar>
      </div>
    )
  }
}

MobileFiltersContainer.defaultProps = {
  aggregations: {},
  filters: {},
  isLoading: false,
}


MobileFiltersContainer.propTypes = {
  // Search aggregations for `SidebarFilters`
  aggregations: PropTypes.object,
  // Applied filters for `SidebarFilters`
  filters: PropTypes.object,
  // If more products are currently being loaded.
  isLoading: PropTypes.bool,
  // onChange callback for `SidebarFilters`
  onChange: PropTypes.func,
}

export default MobileFiltersContainer
